__turbopack_context__.v({
  "menu": "navigation-mobile-module-scss-module__Np_MyG__menu",
  "menuIndex": "navigation-mobile-module-scss-module__Np_MyG__menuIndex",
  "menuItem": "navigation-mobile-module-scss-module__Np_MyG__menuItem",
  "menuText": "navigation-mobile-module-scss-module__Np_MyG__menuText",
  "navContent": "navigation-mobile-module-scss-module__Np_MyG__navContent",
  "navigation": "navigation-mobile-module-scss-module__Np_MyG__navigation",
});
